/*eslint-disable eqeqeq*/
import React from "react";
import * as APIController from '../../../../api/APIController.js';
import Table from "../../../../shared/components/table/table";
import TableHead from "../../../../shared/components/table/tableHead";
import TableRow from "../../../../shared/components/table/tableRow";
import TableBody from "../../../../shared/components/table/tableBody";
import TableCell from "../../../../shared/components/table/tableCell";
import double_left_arrow from '../../../../assets/images/left-doble-arow.svg';
import left_arrow from '../../../../assets/images/left-arrow.svg';
import double_right_arrow from '../../../../assets/images/right-doble-arow.svg';
import right_arrow from '../../../../assets/images/right-arrow.svg';
import "react-perfect-scrollbar/dist/css/styles.css";
import PageTitle from "../../../../config/pageTitle";
import * as AppConstant from "../../../../config/AppConstant";
import PerfectScrollbar from "react-perfect-scrollbar";

import deleteIcon from '../../../../assets/images/delete.svg'
import editIcon from '../../../../assets/images/edit.svg'
import filtericon from '../../../../assets/images/ic_feather_filter.svg'
import viewIcon from '../../../../assets/images/view_icon.png'
import settingIcon from "../../../../assets/images/settings.svg";
import logFileIcon from "../../../../assets/images/icon/logfile.png";

import Modal from '../../../../shared/components/modal/modal';
import ConfirmtionDialog from '../../../ConfirmDialog/ConfirmationDialog';
import Notification from '../../../../shared/components/notification/notification';
import CircularProgress from "../../../../shared/components/CircularProgress/CircularProgress";
import TemplatePopupList from "../componentMasterTemplate/templatePopupList";
import LogsPopupList from "../componentMasterTemplate/logsPopupList";
// import second from '../componentMasterTemplate/templatePopupList'
import close_icon from "../../../../assets/images/close_icon.svg";
import { setISODay } from "date-fns";

const LandingPageUserList = (props) => {
	const headerList = ['action', "Practice Name", "Full Name", "Email Address", "Ship To #", "Zipcode", "Address", "City"]
	const { currentPage, count, rowsPerPage, rowsPerPageOptions, list, to, from } = props;
	let listData = list;
	// listData = list.slice(from, to)

	const [openDialog, setOpenDialog] = React.useState(false);
	const [viewDialog, setViewDialog] = React.useState(false);
	const [isLogsDialog, setIsLogsDialog] = React.useState(false);
	const [BrandsData, setBrandsData] = React.useState([]);
	const [DeleteId, setDeleteId] = React.useState('');
	const [isLoading, setIsLoading] = React.useState(false);

	const [PracticeName, setPracticeName] = React.useState('');
	const [FullName, setFullName] = React.useState('');
	const [Postcode, setPostcode] = React.useState('');
	const [EmailAddress, setEmailAddress] = React.useState('');
	const [ShipToNo, setShipToNo] = React.useState('');
	const [Address, setAddress] = React.useState('');
	const [City, setCity] = React.useState('');

	const page = rowsPerPage == 1000000 ? 1 : Math.floor(count / rowsPerPage) + 1;
	// const page = Math.floor(count / rowsPerPage) + 1;

	/**
	 * handleChangeInCurrentPage method is used to change page number
	 * it will check that page number does not exist last page
	 * @param {*} value 
	 */
	const handleChangeInCurrentPage = (value) => {
		if (value <= page && Number(parseInt(value))) {
			props.handleChangePage(Number(value), PracticeName, FullName, EmailAddress, ShipToNo, Postcode, Address, City);
		}
	}

	const wsGenerateLandingPageForPractice = (ID) => {
		setIsLoading(true)
		APIController.GenerateLandingPageForPractice(ID)
			.then((response) => {
				if (response.error == null) {
					if (response.object.status == 1) {
						props.handleNotification(response.object.message);
					} else {
						props.handleNotification(response.object.message, true);
					}
					props.handlebind()
					setOpenDialog(false)
					setIsLoading(false)
				}
				else if (response.error.message && response.error.message.length > 0) {
					props.handleNotification(response.error.message)
				}
			})
	}

	const [message, setMessage] = React.useState("");
	const [showNotification, setShowNotification] = React.useState(false);
	const [isError, setIsError] = React.useState(false);

	const handleClearNotification = () => {
		setMessage('')
		setShowNotification(false)
		setIsError(false)
	}

	const _handleKeyDown = (e) => {
		if (e.key === 'Enter') {
			props.applyFilter(PracticeName, FullName, EmailAddress, ShipToNo, Postcode, Address, City)
		}
	}

	return (
		<>
			<h1><PageTitle Title={AppConstant.ContactDetais.ViewLandingPageUser} /></h1>
			<div className="table-main-wrap">
				<PerfectScrollbar component='div'>
					<Table>
						<TableHead>
							<TableRow>
								{headerList.map((obj, index) => { return <TableCell style={index == 0 ? { width: '10%' } : index == index.length - 1 ? { width: '10%' } : { width: '80%' }} key={index}>{obj}</TableCell>; })}
							</TableRow>
							<TableRow>
								{/* // PracticeName, FullName, EmailAddress, ShipToNo, Postcode, Address, City */}
								<TableCell style={{ minWidth: '100px' }}> <span><img src={filtericon} alt="delete" /></span> </TableCell>
								{/* <TableCell> <input type="text" name="" placeholder="Practice Name" onChange={(e) => props.applyFilter('PracticeName', e.target.value, 'input')} /> </TableCell> */}
								<TableCell> <input type="text" name="" placeholder="Practice Name" onKeyDown={_handleKeyDown} onChange={(e) => setPracticeName(e.target.value)} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Full Name" onKeyDown={_handleKeyDown} onChange={(e) => setFullName(e.target.value)} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Email Address" onKeyDown={_handleKeyDown} onChange={(e) => setEmailAddress(e.target.value)} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Ship To #" onKeyDown={_handleKeyDown} onChange={(e) => setShipToNo(e.target.value)} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Postcode" onKeyDown={_handleKeyDown} onChange={(e) => setPostcode(e.target.value)} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="Address" onKeyDown={_handleKeyDown} onChange={(e) => setAddress(e.target.value)} /> </TableCell>
								<TableCell> <input type="text" name="" placeholder="City" onKeyDown={_handleKeyDown} onChange={(e) => setCity(e.target.value)} /> </TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{!!listData.length ? listData.map((obj, idnex) => {
								return (
									<TableRow key={idnex}>
										<TableCell>
											<span>
												<img src={viewIcon} alt="view" style={{ cursor: 'pointer', marginRight: '5px' }}
													onClick={() => {
														obj.Brands != "" && obj.Brands != [] && obj.Brands != undefined && obj.Brands != null && setBrandsData(JSON.parse(obj.Brands));
														setIsLogsDialog(false); setViewDialog(true); setOpenDialog(true);
													}} />
												<img src={settingIcon} alt="setting" style={{ cursor: 'pointer', marginRight: '5px' }}
													onClick={() => { setDeleteId(obj.ID); setIsLogsDialog(false); setViewDialog(false); setOpenDialog(true); }} />
												<img src={logFileIcon} alt="log" style={{ cursor: 'pointer' }}
													onClick={() => { setDeleteId(obj.ID); setIsLogsDialog(true); setViewDialog(false); setOpenDialog(true); }} />
											</span>
										</TableCell>
										<TableCell> {obj.PracticeName} </TableCell>
										<TableCell> {obj.FullName} </TableCell>
										<TableCell> {obj.EmailAddress} </TableCell>
										<TableCell> {obj.ShipToNo} </TableCell>
										<TableCell> {obj.Postcode} </TableCell>
										<TableCell> {obj.Address} </TableCell>
										<TableCell> {obj.City} </TableCell>
									</TableRow>
								);
							}) : <TableRow>
								<TableCell colSpan={headerList.length} className="not_found">
									{props.progress ?
										<CircularProgress /> :
										<label>Not Currently Available</label>}
								</TableCell>
							</TableRow>}
						</TableBody>
					</Table>
				</PerfectScrollbar>
			</div>
			<Notification
				isError={isError}
				message={message}
				showNotification={showNotification}
				closeNotification={handleClearNotification.bind(this)}
			/>
			{openDialog && (
				<Modal
					show={openDialog}
					handleClose={() => setOpenDialog(false)}>
					{viewDialog ?
						<div className='popup-wrap'>
							<TemplatePopupList
								title={"View Templates"}
								brandsData={() => BrandsData}
								closeModal={() => setOpenDialog(false)} />
							<img src={close_icon} alt='icon' className='gray-close-ic' onClick={() => setOpenDialog(false)} style={{ cursor: 'pointer' }} />
						</div>
						: isLogsDialog
							? <div className='popup-wrap'>
								<LogsPopupList
									title={"View Logs"}
									templateID={0}
									practiceID={DeleteId}
									closeModal={() => setOpenDialog(false)} />
								<img src={close_icon} alt='icon' className='gray-close-ic' onClick={() => setOpenDialog(false)} style={{ cursor: 'pointer' }} />
							</div>
							: <ConfirmtionDialog
								title={"Generate Landing Page"}
								description={"Are you sure you want to Generate Landing Page?"}
								btnText={'Generate'}
								isLoading={isLoading}
								deletePress={() => wsGenerateLandingPageForPractice(DeleteId)}
								closeModal={() => setOpenDialog(false)}
							/>}
				</Modal>
			)}
			<div className="table-pagination">
				<div className="pagination-info">
					<p>Showing {from + 1} - {to > count ? count : to} of {count}</p>
				</div>
				<div className="pagination-control">
					<a href="#!" title="" className={`double-left-arrow ${currentPage === 1 || currentPage === 0 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(1)
						}}
					><img src={double_left_arrow} alt="left" /></a>
					<a href="#!" title="" className={`simple-left-arrow ${currentPage === 1 || currentPage === 0 ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage - 1)
						}}
					><img src={left_arrow} alt="single_left" /></a>
					<span>Page</span>
					<input type="text" name="textbox" value={currentPage === 0 ? currentPage + 1 : currentPage} onChange={(e) => handleChangeInCurrentPage(e.target.value)} />
					<span>of {page}</span>
					<a href="#!" title="" className={`simple-right-arrow ${currentPage === page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(currentPage + 1)
						}}
					><img src={right_arrow} alt="right" /></a>
					<a href="#!" title="" className={`double-right-arrow ${currentPage === page ? 'disabled' : ''}`}
						onClick={(e) => {
							e.preventDefault();
							handleChangeInCurrentPage(page)
						}}><img src={double_right_arrow} alt="single_right" /></a>
					<select onChange={(e) => props.handleChangeRowsPerPage(parseInt(e.target.value), PracticeName, FullName, EmailAddress, ShipToNo, Postcode, Address, City)} defaultValue={rowsPerPage}>
						{
							rowsPerPageOptions.map((obj, index) => {
								return <option value={obj} key={index}>{obj}</option>
							})
						}
					</select>
				</div>
			</div>
		</>
	);
};

export default LandingPageUserList;
